import React from 'react'
import { FormFeedback, FormGroup, Label, Input } from 'reactstrap'
import Switch from 'react-toggle-switch';
import MaskedInput from 'react-text-mask';

const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

export const renderHelpText = text => {
  if (!text) { return null; }
  return <small className="form-text text-muted">{text}</small>;
};

export const renderField = ({ input, options, label, placeholder, type, helpText, disabled, required, meta: { touched, error } }) => {
  let field;

  switch (type) {
    case 'select': {
      field = (
        <Input {...input} type={type} className="form-control">
          <option></option>
          { options.map(opt =>
            <option key={opt.value} value={opt.value}>{opt.key}</option>
          )}
        </Input>
      );
      break;
    }

    case 'checkbox': {
      return (
        <FormGroup check color={(touched && error) ? 'danger' : ''}>
          <Label check>
            <Input {...input} type="checkbox" />{'  '}
            {label}
          </Label>
          {touched && (error && <FormFeedback>{error}</FormFeedback>)}
        </FormGroup>
      )
    }

    case 'switch': {
      let value = (input.value === '' ? false : input.value)

      field = (
        <div>
          <Switch on={value} onClick={() => input.onChange(!value)}/>
        </div>
      )
      break;
    }

    case 'phone':
      field = (
        <MaskedInput
          {...input}
          type="text"
          className="form-control"
          mask={phoneMask}
        />
      );
      break;

    default: {
      field = <Input {...input} placeholder={placeholder} type={type} disabled={disabled} />
    }
  }

  return (
    <FormGroup className={(touched && error) ? 'danger' : ''}>
      {label && <Label for={label} className={required ? 'required' : ''}>{label}</Label>}
      {field}
      {touched && (error && <FormFeedback>{error}</FormFeedback>)}
      {renderHelpText(helpText)}
    </FormGroup>
  )
};



// WEBPACK FOOTER //
// ./src/core/utils/form.js